import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { perfil } from 'src/app/models/perfil';
import { AlertifyService } from 'src/app/services/alertify.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-edit-detalle-usuarios',
  templateUrl: './edit-detalle-usuarios.component.html',
  styleUrls: ['./edit-detalle-usuarios.component.scss'],
})
export class EditDetalleUsuariosComponent implements OnInit {
  public documentos: any;
  public perfiles: perfil[];
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public tituloTxt = 'Actualizar deportista';

  constructor(
    public usrSvc: UserService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditDetalleUsuariosComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);

    this.tituloTxt = 'Actualizar deportista ' + data.nombre;
  }

  ngOnInit(): void {
    this.inicarFormulario();
  }

  inicarFormulario() {
    this.registerForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      contactoNombre: new UntypedFormControl(''),
      contactoTelefono: new UntypedFormControl(''),
      direccion: new UntypedFormControl(''),
      telefono: new UntypedFormControl(''),
      eps: new UntypedFormControl('', Validators.required),
      fechaNacimiento: new UntypedFormControl(''),
      rh: new UntypedFormControl(''),
      sexo: new UntypedFormControl(''),
    //  tipoAfiliacion: new FormControl(''),
      estado: new UntypedFormControl(''),
    });
    this.registerForm.get('estado')?.setValue(0);

    this.usrSvc.getDetalleUsuario(this.dataInput.id).subscribe((x) => {
      console.log('datos detalle usuario: ', x);
      if (this.dataInput != null) {
        this.registerForm.get('id')?.setValue(this.dataInput.id);
        this.registerForm.get('contactoNombre')?.setValue(x.contactoNombre);
        this.registerForm.get('contactoTelefono')?.setValue(x.contactoTelefono);
        this.registerForm.get('direccion')?.setValue(x.direccion);
        this.registerForm.get('telefono')?.setValue(x.telefono);
        this.registerForm.get('eps')?.setValue(x.eps);
        this.registerForm.get('fechaNacimiento')?.setValue(x.fechaNacimiento);
        this.registerForm.get('rh')?.setValue(x.rh);
        this.registerForm.get('sexo')?.setValue(x.sexo + '');
     //   this.registerForm.get('tipoAfiliacion')?.setValue(x.tipoAfiliacion);
        this.registerForm.get('estado')?.setValue(x.estado == 1);
      }
    });
  }

  guardar() {
    console.log('guardar datos usuario');

    // this.registerForm.get('sexo')?.setValue(this.dataInput.sexo);
    this.registerForm
      .get('sexo')
      ?.setValue(this.registerForm.get('sexo')?.value == '0' ? 0 : 1);
    this.registerForm
      .get('estado')
      ?.setValue(this.registerForm.get('estado')?.value ? 1 : 3);
    console.log(this.registerForm.get('estado')?.value);
    console.log(this.registerForm.value);

    this.usrSvc.setDetalleUsuario(this.registerForm.value).subscribe((res) => {
      console.log('resultado EditarUsuario: ', res);
      if (res) {
        this.alertify.success('Deportista actualizado correctamente');
        this.dialogRef.close();
      } else {
        this.alertify.error('El deportista no se ha podido actualizar');
      }
    });
  }
}